import { createContext, useContext } from 'react';

export interface IPostColumnsContext {
  layout?: string;
  autoColumnWidth?: number;
}

export const PostColumnsContext = createContext<IPostColumnsContext>({});

export function usePostColumnsContext() {
  const context = useContext(PostColumnsContext);

  if (!context) {
    throw new Error('usePostColumnsContext must be used within a PostColumns');
  }

  return context;
}
